<div class="cities-selected-modal" >
  <div class="modal-header border-0 direction-right">
    <h5 style="width: 65%; " class="modal-title direction-right font-weight-bold">
      {{ (isEdit ? 'distribution-array.edit_distribution' : 'distribution-array.new_distribution') | translate}}
    </h5>
    <button type="button" class="close btn pt-1 pr-2 m-0" aria-label="Close"
            (click)="activeModal.close({})">
      <i style="font-size: 20px;" class="fas fa-times text-white" [class.text-white]="!isRTL"></i>
    </button>
  </div>
  <form  class="direction-right" [formGroup]="formGroup" (ngSubmit)="onCreateSubmit()">
    <div class="modal-footer border-0" style="direction: ltr; justify-content: center;">
      <button type="submit" class="btn btn-primary py-1 px-4 px-lg-5">
        {{'modal.OK' | translate}}
      </button>
      <button type="button" class="btn btn-info py-1 px-4 px-lg-5" (click)="activeModal.close({})">
        {{'modal.cancel' | translate}}
      </button>
    </div>
    <div  class="modal-body" >
      <div class="col-7 px-0">
        <div class="form-group" style="width: 500px;">
          <!--            <label class="w-100 direction-right" for="name">{{'recipe.recipe_name' | translate}}</label>-->
          <div *ngIf="!takeAway">
          <label class="w-100 direction-right"  for="">{{"store-setting.distribution_cities"| translate }}</label>
          <ng-multiselect-dropdown
            placeholder="{{'distribution-array.cities'| translate }}"
            [settings]="dropdownSettings"
            [data]="dropdownList"
            [(ngModel)]="selectedItems"
            [ngModelOptions]="{standalone: true}"
            (onSelect)="onItemSelect($event)"
            (onSelectAll)="onSelectAll($event)"
          >
          </ng-multiselect-dropdown>
          </div>
          <label
            style="margin-top: 10px"
            class="w-100 direction-right">

            {{"store-setting.distribution_hours" | translate }}
          </label>

          <div *ngFor="let day of ['א', 'ב', 'ג', 'ד', 'ה', 'ו']; let i = index" class="row align-items-center mb-3" style="display: flex; gap: 2px;">
            <div class="col-auto">
              <input type="checkbox" [formControlName]="'enableTimepicker' + day" (change)="toggleTimepicker($event, day)">
            </div>
            <div class="col-auto">
              <label [for]="'enableTimepicker' + day" class="text-center"> {{'distribution-array.day'| translate }} {{day}} </label>
            </div>

<!--            <div class="col-auto" style="flex-grow: 1; display: flex; justify-content: flex-end;">-->
<!--              <div [ngClass]="{ 'disabled': formGroup.get('general_from_time_end' + day)?.disabled }">-->
<!--                <div class="text-center">-->
<!--                  <label [for]="'enableTimepicker' + day"> {{'distribution-array.end'| translate }} </label>-->
<!--                </div>-->
<!--                <div style="direction: ltr;"> &lt;!&ndash; Set direction to left-to-right &ndash;&gt;-->
<!--                  <ngb-timepicker [formControlName]="'general_from_time_end' + day"></ngb-timepicker>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col-auto" style="flex-grow: 1; display: flex; justify-content: flex-end;">-->
<!--              <div [ngClass]="{ 'disabled': formGroup.get('general_from_time_end' + day)?.disabled }">-->
<!--                <div style="direction: ltr;"> &lt;!&ndash; Set direction to left-to-right &ndash;&gt;-->
<!--                  <h2>-</h2>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col-auto" style="flex-grow: 1; display: flex; justify-content: flex-start;">-->
<!--              <div [ngClass]="{ 'disabled': formGroup.get('general_from_time_start' + day)?.disabled }">-->
<!--                <div class="text-center">-->
<!--                  <label [for]="'enableTimepicker' + day"> {{'distribution-array.start'| translate }} </label>-->
<!--                </div>-->
<!--                <div style="direction: ltr;"> &lt;!&ndash; Set direction to left-to-right &ndash;&gt;-->
<!--                  <ngb-timepicker [formControlName]="'general_from_time_start' + day"></ngb-timepicker>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->


            <div class="col-auto" style="flex-grow: 1; display: flex; justify-content: flex-end;">
              <div *ngIf="!formGroup.get('general_from_time_end' + day)?.disabled ">
                <div class="text-center">
                  <label [for]="'enableTimepicker' + day"> {{'distribution-array.end'| translate }} </label>
                </div>
                <div style="direction: ltr;"> <!-- Set direction to left-to-right -->
                  <ngb-timepicker [formControlName]="'general_from_time_end' + day"></ngb-timepicker>
                </div>
              </div>
            </div>
            <div class="col-auto" style="flex-grow: 1; display: flex; justify-content: flex-end;">
              <div *ngIf="!formGroup.get('general_from_time_end' + day)?.disabled">
                <div style="direction: ltr;"> <!-- Set direction to left-to-right -->
                  <h2>-</h2>
                </div>
              </div>
            </div>
            <div class="col-auto" style="flex-grow: 1; display: flex; justify-content: flex-start;">
              <div *ngIf="!formGroup.get('general_from_time_start' + day)?.disabled">
                <div class="text-center">
                  <label [for]="'enableTimepicker' + day"> {{'distribution-array.start'| translate }} </label>
                </div>
                <div style="direction: ltr;"> <!-- Set direction to left-to-right -->
                  <ngb-timepicker [formControlName]="'general_from_time_start' + day"></ngb-timepicker>
                </div>
              </div>
            </div>

            <!-- Divider line -->
            <div class="col-12">
              <hr>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="modal-footer border-0" style="direction: ltr; justify-content: center;">
      <button type="submit" class="btn btn-primary py-1 px-4 px-lg-5">
        {{'modal.OK' | translate}}
      </button>
      <button type="button" class="btn btn-info py-1 px-4 px-lg-5" (click)="activeModal.close({})">
        {{'modal.cancel' | translate}}
      </button>
    </div>
  </form>
</div>

